import angular from 'angular';
import submitEnhancements from './submitEnhancements';

export default angular
  .module('components.submitEnhancements', [])
  .component('submitEnhancements', submitEnhancements).name;
